import {
  Col,
  Form,
  Input,
  Row,
  Card,
  Select,
  Radio,
  DatePicker,
  Modal,
  Table,
  Space,
  message,
} from "antd";
import { Option } from "antd/lib/mentions";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import Link from "antd/lib/typography/Link";
import { getCategoryList } from "../../../redux/PricingSetupCategory/pricingSetupCategoryAction";
import { connect } from "react-redux";
import { InputNumber } from "antd";

const PricingFormQuery = ({
  partnerCode,
  pricingdataToSubmit,
  setpricingdataToSubmit,
  existingPricingData,
  setEditranch,
  ...props
}) => {
  const [form] = Form.useForm();
  const [isModalChange, setIsModalChange] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [minSlab, setMinSlab] = useState("");
  const [maxSlab, setMaxSlab] = useState("");
  const [pricingEdit, setpricingEdit] = useState(false);
  const [percentage, setPercentage] = useState("");
  const [fixedPercentage, setFixedPercentage] = useState("");
  const [approvalStaus, setApprovalStaus] = useState(null);
  const [editFixId, setEditFixId] = useState(null);
  const [editPricingId, setEditPricingId] = useState("");
  const [fixedStaus, setFixedStause] = useState(false);
  const [pricingDatasorce, setPricingDatasorce] = useState([]);
  const [formStatus, setFormStatus] = useState([]);
  const [formValueSetup, setFormValueSetup] = useState([]);
  const [existingPricingDeta1, setExistingPricingData1] = useState(
    props.existingPricingDetail
  );
  const { editformData, accessToken, sendQueryData } = props;

  useEffect(() => {
    
    const fetchData = async () => {
      try {
        const dataSetup = props.categorySetup({
          accessToken: accessToken,
        });
        const getValueSetup = await dataSetup;
        setFormValueSetup(getValueSetup);
      } catch (e) {
        console.log(e);
      }
    };

    fetchData();
  }, [props.formSetup]);

  useEffect(() => {

    if (editformData) {
      // Map editformData to form field names
      const mappedData = {
        disbursement_type: editformData.disbursement,
        Business_type: editformData.Business,
        Segment_type: editformData.Segment,
        Stream_type: editformData.Stream,
        Country: editformData.country,
        effective_date: editformData.EffDate
          ? moment(editformData.EffDate, "YYYY-MM-DD")
          : null,
        Pricing_type: editformData.Pricing,
        Retrospective: editformData.retrospective,
        Fixed_percentage: editformData.pricingDetails[0]?.Percentage
          ? editformData.pricingDetails[0]?.Percentage
          : null,
      };

      // Populate form fields with mapped data
      form.setFieldsValue(mappedData);

      // Update state variables based on Pricing_type
      if (editformData.Pricing === 1) {
        setFixedStause(true);
        setApprovalStaus(editformData.ApprovalStage);
        setEditFixId(editformData.pricingDetails[0]?.pricingId);
        setFixedPercentage(editformData.pricingDetails[0]?.Percentage || "");
      } else if (editformData.Pricing === 2) {
        setFixedStause(false);
        setApprovalStaus(editformData.ApprovalStage);

        const editformDataWithActionMaped = (
          editformData.pricingDetails || []
        ).map((entry, index) => {
          const uKey = generateGuid();
          return {
            ...entry,
            key: entry.pricingId, // Add a unique key for each entry
            Action: (
              <Button
                type="link"
                onClick={() =>
                  handleEditEntry(entry.pricingId, editformDataWithActionMaped)
                }
                style={{ background: "#1b8593" }}
              >
                <EditOutlined />
              </Button>
            ),
          };
        });

        setDataSource([...editformDataWithActionMaped].sort((a, b) => parseFloat(a.MinimumSlab) - parseFloat(b.MinimumSlab)));
      }
    }
  
  }, [editformData, form]);

  useEffect(() => {
    
    setExistingPricingData1(props.existingPricingDetail);
    
  }, [props.existingPricingDetail]);



  const handleAddEntry = () => {
    // Validation
    if (
      parseInt(minSlab) < 0 ||
      parseInt(maxSlab) < 0 || // Allow 0 for maxSlab
      (parseFloat(maxSlab) !== 0 && parseFloat(maxSlab) <= parseFloat(minSlab)) // Ensure maxSlab > minSlab unless maxSlab is 0
    ) {
      message.error("Entering Slab not allowed. Maximum Slab must be greater than Minimum Slab.");
      return 0;
    } else if (minSlab === "" || maxSlab === "" || percentage === "") {
      message.error("Please enter some value!");
      return 0;
    } else if (
      isNaN(parseFloat(percentage)) ||
      parseFloat(percentage) <= 0 ||
      parseFloat(percentage) > 99.99 // Allow percentage between 0.01 and 99.99
    ) {
      message.error("Entering percentage not allowed (0.01-99.99)");
      return 0;
    }

    // Ensure the first MinimumSlab is 0
    if (dataSource.length === 0 && parseFloat(minSlab) !== 0) {
      message.error("The first Minimum Slab must be 0.");
      return 0;
    }

    // Check if slabs are in sequence
    if (dataSource.length > 0) {
      const lastEntry = dataSource[dataSource.length - 1];
      const lastMaxSlab = parseFloat(lastEntry.MaximumSlab);
      const currentMinSlab = parseFloat(minSlab);
      if (lastMaxSlab === 0) {
        message.error("Not allowed to add more slabs after 0");
        return 0;
      }

      if (currentMinSlab !== lastMaxSlab + 0.01) {
        message.error(
          `Slabs must be in sequence. The next Minimum Slab should be ${lastMaxSlab + 0.01}.`
        );
        return 0;
      }


    }

    // Allow MaximumSlab to be 0 only for the last entry
    if (parseFloat(maxSlab) === 0) {
      const hasZeroMaxSlab = dataSource.some(
        (entry) => parseFloat(entry.MaximumSlab) === 0
      );
      if (hasZeroMaxSlab) {
        message.error("Only one entry can have Maximum Slab as 0.");
        return 0;
      }
    }

    const newEntry = {
      key: dataSource.length + 1,
      MinimumSlab: minSlab,
      MaximumSlab: maxSlab,
      Percentage: percentage,
      Action: (
        <Button
          type="link"
          onClick={() => handleDeleteEntry(newEntry.key)}
          style={{ background: "#1b8593" }}
        >
          {" "}
          <DeleteOutlined />
        </Button>
      ),
    };

    setDataSource([...dataSource, newEntry].sort((a, b) => parseFloat(a.MinimumSlab) - parseFloat(b.MinimumSlab)));
    setMinSlab("");
    setMaxSlab("");
    setPercentage("");
  };



  const handleDeleteEntry = (key) => {
   

    const updatedDataSource = dataSource.filter((item) => item.key !== key);
    setDataSource(updatedDataSource);
    
  };

  const handleEditEntry = (key, updatedDataSource = dataSource) => {
   
    setpricingEdit(true);

    const entryToEdit = updatedDataSource.find((item) => item.key === key);
    if (entryToEdit) {
      setMinSlab(entryToEdit.MinimumSlab);
      setMaxSlab(entryToEdit.MaximumSlab);
      setPercentage(entryToEdit.Percentage);
      setEditPricingId(entryToEdit.pricingId);
    }
    
  };

  const handleAddEditedEntry = () => {
    // Validation
    if (
      parseInt(minSlab) < 0 ||
      parseInt(maxSlab) < 0 || // Allow 0 for maxSlab
      (parseFloat(maxSlab) !== 0 && parseFloat(maxSlab) <= parseFloat(minSlab)) // Ensure maxSlab > minSlab unless maxSlab is 0
    ) {
      message.error("Entering Slab not allowed. Maximum Slab must be greater than Minimum Slab.");
      return 0;
    } else if (minSlab === "" || maxSlab === "" || percentage === "") {
      message.error("Please enter some value!");
      return 0;
    } else if (
      isNaN(parseFloat(percentage)) ||
      parseFloat(percentage) <= 0 ||
      parseFloat(percentage) > 99.99  // Allow percentage between 0.01 and 99.99
    ) {
      message.error("Entering percentage not allowed (0.01-99.99)");
      return 0;
    }


    // Prevent both MinimumSlab and MaximumSlab being 0
    if (parseFloat(minSlab) === 0 && parseFloat(maxSlab) === 0) {
      message.error("Both Minimum Slab and Maximum Slab cannot be 0 as it will be fixed percentage.");
      return 0;
    }

    // Check for duplicates (excluding the current editing entry)
    const isDuplicate = dataSource.some(
      (entry) =>
        entry.pricingId !== editPricingId && // Exclude the current editing entry
        entry.MinimumSlab === minSlab &&
        entry.MaximumSlab === maxSlab &&
        entry.Percentage === percentage
    );

    if (isDuplicate) {
      message.error("Duplicate entry not allowed!");
      return 0;
    }

    // Update the specific entry in the dataSource
    const updatedDataSource = dataSource.map((entry) => {
      if (entry.pricingId === editPricingId) {
        return {
          ...entry,
          oldMinimumSlab: entry.MinimumSlab,
          oldMaximumSlab: entry.MaximumSlab,
          oldPercentage: entry.Percentage,
          MinimumSlab: minSlab,
          MaximumSlab: maxSlab,
          Percentage: percentage,
        };
      }
      return entry;
    });

    setDataSource(updatedDataSource);
    setMinSlab("");
    setMaxSlab("");
    setPercentage("");
    setpricingEdit(false); // Reset editing state
  };

  const generateGuid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };




  const onFinish = (values) => {
    const duplicateMessages = [];


    if (dataSource.length > 0 && fixedStaus === false) {
      // If NO entry has MaximumSlab == 0, show error
      if (!dataSource.some((item) => parseFloat(item.MaximumSlab) === 0)) {
        message.error("Please add slab entry with Maximum Slab as 0");
        return 0;
      }

    }

    const formData = {
      ...values,
      pricingDetails: fixedStaus ? { fixedPercentage } : { slabs: dataSource },
      Country: values.Country[0],//remove when multiple is added
    };

  

    const {
      disbursement_type,
      Business_type,
      Segment_type,
      Stream_type,
      Pricing_type,
      Country,
      effective_date,
      Retrospective,
      pricingDetails,
    } = formData;

    setPricingDatasorce([]);

    // 1. Build a new array for new entries
    let newEntries = [];

    const createAndPushData = (
      disbursement,
      business,
      segment,
      stream,
      array
    ) => {
      const getCategoryCode = (categoryType, id) => {
        const category = formValueSetup[categoryType]?.find(
          (cat) => cat.catId === id
        );
        return category ? category.catCode : null;
      };

      const tracId = generateGuid();

      const getCoboCode = (
        disbursement,
        business,
        segment,
        stream,
        Pricing_type,
        Country
      ) => {

        return `${getCategoryCode("tranche", disbursement)}-${getCategoryCode(
          "business",
          business
        )}-${getCategoryCode("segment", segment)}-${getCategoryCode(
          "stream",
          stream
        )}-${getCategoryCode("priceType", Pricing_type)}-${getCategoryCode(
          "country",
          Country
        )}`;
      };

      const combinationCode = getCoboCode(
        disbursement,
        business,
        segment,
        stream,
        Pricing_type,
        Country
      );

      

      const data = {
        disbursement,
        Business: business,
        Segment: segment,
        Stream: stream,
        Pricing: Pricing_type,
        country: Country,
        PricingCode: combinationCode,
        EffDate: effective_date.format("YYYY-MM-DD"),
        retrospective: Retrospective ? Retrospective : "No",
        pricingDetails,
        partnerCode: partnerCode,
        ApprovalStage: approvalStaus ? approvalStaus : 1,
        tracId: tracId,
      };

      const addDataToArray = (finalData) => {

        const isDuplicate = array?.some((item) => {
          if (finalData.priceTypeId === 2) {
            return (
              item.trancheId === finalData.trancheId &&
              item.businessId === finalData.businessId &&
              item.segmentId === finalData.segmentId &&
              item.streamId === finalData.streamId &&
              item.countryId === finalData.countryId &&
              item.partnerId === finalData.partnerId &&
              item.effectiveDate === finalData.effectiveDate &&
              item.startSlab === finalData.startSlab &&
              item.endSlab === finalData.endSlab &&
              item.percentage === finalData.percentage
            );
          } else if (finalData.priceTypeId === 1) {
            return (
              item.trancheId === finalData.trancheId &&
              item.businessId === finalData.businessId &&
              item.segmentId === finalData.segmentId &&
              item.streamId === finalData.streamId &&
              item.countryId === finalData.countryId &&
              item.partnerId === finalData.partnerId &&
              item.effectiveDate === finalData.effectiveDate &&
              item.percentage === finalData.percentage
            );
          }
          return false;
        });

        
        const existingPricingDeta2 = existingPricingDeta1?.filter((item) => {
          return item.approvalStageId !== 5;
        })
        
        const isDuplicateInExisting = existingPricingDeta2?.some((item) => {
          

          if (item.pricingId === finalData.pricingId) {
            // Ignore duplicates if pricingId matches
            return false;
          }

          if (finalData.priceTypeId === 2) {
          

            return (
              item.trancheId === finalData.trancheId &&
              item.businessId === finalData.businessId &&
              item.segmentId === finalData.segmentId &&
              item.streamId === finalData.streamId &&
              item.countryId === finalData.countryId &&
              item.partnerId === parseInt(finalData.partnerId) &&
              item.effectiveDate === finalData.effectiveDate &&
              item.startSlab === parseInt(finalData.startSlab) &&
              item.endSlab === parseInt(finalData.endSlab) &&
              item.percentage === parseFloat(finalData.percentage)
            );
          } else if (finalData.priceTypeId === 1) {
            return (
              item.trancheId === finalData.trancheId &&
              item.businessId === finalData.businessId &&
              item.segmentId === finalData.segmentId &&
              item.streamId === finalData.streamId &&
              item.countryId === finalData.countryId &&
              item.partnerId === parseInt(finalData.partnerId) &&
              item.effectiveDate === finalData.effectiveDate &&
              item.percentage === parseFloat(finalData.percentage)
            );
          }
          return false;
        });

       

        if (!isDuplicate && !isDuplicateInExisting) {
          
          newEntries.push(finalData);
        } else {
          const getCategoryName = (categoryType, id) => {
            const category = formValueSetup[categoryType]?.find(
              (cat) => cat.catId === id
            );
            return category ? category.catName : null;
          };
          const messageText = `Duplicate combination found: disbursement=${getCategoryName(
            "tranche",
            disbursement
          )}, Business=${getCategoryName(
            "business",
            business
          )}, Segment=${getCategoryName(
            "segment",
            segment
          )}, Stream=${getCategoryName(
            "stream",
            stream
          )}, Country=${getCategoryName("country", Country)}`;
          
          duplicateMessages.push(messageText);
        }
      };

      if (data.Pricing === 2) {
        data.pricingDetails.slabs.forEach((slab) => {
          if (slab.pricingId == undefined && slab.pricingId == null) {
            const finalData = {
              trancheId: data.disbursement,
              businessId: data.Business,
              segmentId: data.Segment,
              streamId: data.Stream,
              priceTypeId: data.Pricing,
              countryId: data.country,
              pricingCode: data.PricingCode,
              effectiveDate: data.EffDate,
              retrospective: data.retrospective,
              startSlab: slab.MinimumSlab,
              endSlab: slab.MaximumSlab,
              percentage: slab.Percentage,
              pricingId: slab.pricingId ? slab.pricingId : null,
              partnerId: data.partnerCode,
              approvalStageId: data.ApprovalStage,
              tracId: tracId,
            };
            addDataToArray(finalData);
          }
        });
      } else if (data.Pricing === 1) {
        const finalData = {
          trancheId: data.disbursement,
          businessId: data.Business,
          segmentId: data.Segment,
          streamId: data.Stream,
          priceTypeId: data.Pricing,
          countryId: data.country,
          pricingCode: data.PricingCode,
          effectiveDate: data.EffDate,
          retrospective: data.retrospective,
          startSlab: 0,
          endSlab: 0,
          percentage: data.pricingDetails.fixedPercentage,
          pricingId: editFixId ? editFixId : null,
          partnerId: data.partnerCode,
          approvalStageId: data.ApprovalStage,
          tracId: tracId,
        };
        addDataToArray(finalData);
      }
    };


    // Helper to add new combinations
    const addNewCombinations = () => {
      
      disbursement_type.forEach((disbursement) => {
        Business_type.forEach((business) => {
          Segment_type.forEach((segment) => {
            Stream_type.forEach((stream) => {
              createAndPushData(
                disbursement,
                business,
                segment,
                stream,
                pricingdataToSubmit
              );
            });
          });
        });
      });
    };

    if (dataSource.some(entry => entry.oldMaximumSlab !== undefined)) {
      // Edit slab-based entries
      let updatedPricingData = pricingdataToSubmit.map((item) => {
        const editedEntry = dataSource.find(
          (entry) =>
            entry.oldMaximumSlab !== undefined &&
            item.startSlab === entry.oldMinimumSlab &&
            item.endSlab === entry.oldMaximumSlab &&
            item.percentage === entry.oldPercentage &&
            item.trancheId === disbursement_type[0] // Assuming you want to match the first trancheId
        );
        if (editedEntry) {
          return {
            ...item,
            startSlab: editedEntry.MinimumSlab,
            endSlab: editedEntry.MaximumSlab,
            percentage: editedEntry.Percentage,
          };
        }
        return item;
      });

      // Add new slab-based entries (those without pricingId)
      const newdataSource = dataSource
        .filter(entry => entry.oldMaximumSlab === undefined && entry.pricingId == undefined);

      
      const newformData = {
        ...values,
        pricingDetails: { slabs: newdataSource },
      };
      

      setpricingdataToSubmit(updatedPricingData);
      if (newdataSource.length > 0) {
        addNewCombinations();
      }

      

    } else if (editFixId) {
      // Edit fixed percentage
      if (fixedPercentage !== "") {
        let fixedData = pricingdataToSubmit.map((item) => {
          if (item.priceTypeId === 1 && item.trancheId === disbursement_type[0]) {
            return { ...item, percentage: fixedPercentage };
          }
          return item;
        });
        setpricingdataToSubmit(fixedData);
      }
    } else {
      // Add new entries (fixed or slab)
      addNewCombinations();
    }


    // setpricingdataToSubmit((prevData) => [...prevData]);
    // 4. Merge with previous state if needed
    setpricingdataToSubmit((prevData) => [...prevData, ...newEntries]);
   


    if (duplicateMessages.length > 0) {
      message.error(duplicateMessages.length + " Duplicate entries found!");
      duplicateMessages.forEach((msg) => message.error(msg));
    }

    onReset();
    setEditranch(null);
  };

  

  const onFinishFailed = (errorInfo) => {
    
    const err = errorInfo.errorFields[0].errors[0];
    message.error(err);
  };

  const onReset = () => {
    form.resetFields();
    setFixedStause(false);
    setDataSource([]);
    form.setFieldsValue({ Fixed_percentage: "" });
  };

  const slabOptions = [
    {
      label: "Fixed",
      value: "Fixed",
    },
    {
      label: "Slab Based",
      value: "Slab Based",
    },
  ];

  const slabOptions1 = formValueSetup.priceType?.map((item) => {
    return {
      label: item.catName,
      value: item.catId,
    };
  });

  const RetroOptions = [
    {
      label: "Yes",
      value: "Yes",
    },
    {
      label: "No",
      value: "No",
    },
  ];

  const handleSlabViewClicked = () => {
    showModal();
    
  };

  const handleSlabRadioClicked = (e) => {

    if (e.target.value === 2) {
      setFixedStause(false);
      setFixedPercentage("");
      showModal();
    } else if (e.target.value === 1) {
      setFixedStause(true);
      setDataSource([]);
      showModal();
    }
    
  };

  const disabledDate = (current) => {
    return current && current <= moment().endOf("day");
  };

  const showModal = () => {
    setIsModalChange(true);
    setDrawerOpen(true);
  };

  const handleCancel = () => {
    setIsModalChange(false);
    setDrawerOpen(false);
    if (editPricingId !== "") {
      setDataSource([]);
    }
  };

  const handleCancelFixed = () => {
    setIsModalChange(false);
    setDrawerOpen(false);
    setFixedStause(false);
    setFixedPercentage("");
  };

  const handleConfirm = () => {
    
    if (dataSource.length > 0) {
      const lastEntry = dataSource[dataSource.length - 1];
      

      if (parseFloat(lastEntry.MaximumSlab) !== 0) {
        message.error("last MaxSlab must be 0");
        return 0;
      }
    }
    setIsModalChange(false);
    setDrawerOpen(false);
    setFixedStause(false);
    // setFixedPercentage("");
  };

  const handleConfirmFixed = () => {
    if (
      isNaN(parseFloat(fixedPercentage)) ||
      parseFloat(fixedPercentage) < 0 ||
      parseFloat(fixedPercentage) > 99.99
    ) {
      message.error("Entering percentage not allowed (0-99.99)");
      return 0;
    }
    
    setIsModalChange(false);
    setDrawerOpen(false);
  };

  return (
    <>
      <Card>
        <Form
          form={form}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ display: "flex", flexWrap: "wrap" }}
        >
          <Col style={{ width: "30%", paddingLeft: 10, paddingLeft: 0 }}>
            <Form.Item
              label="Disbursement Type"
              name="disbursement_type"
              rules={[
                {
                  required: true,
                  message: "Please select a disbursement type!",
                },
              ]}
            >
              <Select mode="multiple" placeholder="Select a disbursement type"
              //       defaultValue={ form.setFieldsValue({ disbursement_type: formValueSetup.tranche
              //         ?.filter((x) => x.catName === "First" || x.catName === "Other")
              //         .map((x) => x.catId)}, )}

              //         onChange={(selectedValues) => {
              //           const trancIds = formValueSetup.tranche
              //           ?.filter((x) => x.catName === "First" || x.catName === "Other")
              //           .map((x) => x.catId);
              //           trancIds.forEach((id) => {
              //             if (!selectedValues.includes(id)) {
              //               selectedValues.push(id);
              //             }
              //           });
              //           form.setFieldsValue({ disbursement_type: selectedValues }); 
              // }}
              >
                {formValueSetup.tranche
                  ? formValueSetup.tranche.map((x, index) => (
                    <Option key={index} value={x.catId}>
                      {x.catName}
                    </Option>
                  ))
                  : ""}
              </Select>
            </Form.Item>
          </Col>

          <Col style={{ width: "30%", paddingLeft: 10 }}>
            <Form.Item
              label="Business "
              name="Business_type"
              rules={[{ required: true, message: "Please select a business!" }]}
            >
              <Select mode="multiple" placeholder="Select a business"
              // defaultValue={ form.setFieldsValue({ Business_type:  formValueSetup.business
              //   ?.filter((x) => x.catName === "EL" )
              //   .map((x) => x.catId)}, )}
              // onChange={(selectedValues) => {
              //             const eilId = formValueSetup.business?.find((x) => x.catName === "EL")?.catId;
              //             if (!selectedValues.includes(eilId)) {
              //               selectedValues.push(eilId); 
              //             }
              //             form.setFieldsValue({ Business_type: selectedValues }); 
              //   }} 
              >

                {formValueSetup.business
                  ? formValueSetup.business.map((x, index) => (
                    <Option key={index} value={x.catId} disabled={x.catName === "EIL"}>
                      {x.catName}
                    </Option>
                  ))
                  : ""}
              </Select>
            </Form.Item>
          </Col>

          <Col style={{ width: "30%", paddingLeft: 10 }}>
            <Form.Item
              label="Segment"
              name="Segment_type"
              rules={[{ required: true, message: "Please select a segment!" }]}
            >
              <Select mode="multiple" placeholder="Select a segment"
              //       defaultValue={ form.setFieldsValue({ Segment_type: formValueSetup.segment
              //         ?.filter((x) => x.catName === "Domestic" || x.catName === "International")
              //         .map((x) => x.catId)}, )}

              //         onChange={(selectedValues) => {
              //           const segmentIds = formValueSetup.segment
              //           ?.filter((x) => x.catName === "Domestic" || x.catName === "International")
              //           .map((x) => x.catId);
              //           segmentIds.forEach((id) => {
              //             if (!selectedValues.includes(id)) {
              //               selectedValues.push(id);
              //             }
              //           });
              //           form.setFieldsValue({ Segment_type: selectedValues }); 
              // }}
              >
                {formValueSetup.segment
                  ? formValueSetup.segment.map((x, index) => (
                    <Option key={index} value={x.catId}>
                      {x.catName}
                    </Option>
                  ))
                  : ""}
              </Select>
            </Form.Item>
          </Col>
          <Col style={{ width: "30%", paddingRight: 10 }}>
            <Form.Item
              label="Effective Date"
              name="effective_date"
              rules={[
                { required: true, message: "Please select an effective date!" },
              ]}
              // labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <DatePicker
                style={{ width: "100%" }}
                // disabledDate={disabledDate} // Disable past dates
                format="YYYY-MM-DD" // Date format
              />
            </Form.Item>
          </Col>
          <Col style={{ width: "30%" }}>
            <Form.Item
              label="Stream"
              name="Stream_type"
              rules={[{ required: true, message: "Please select a stream!" }]}
            >
              <Select mode="multiple" placeholder="Select a stream"
              //       defaultValue={ form.setFieldsValue({ Stream_type: formValueSetup.stream
              //         ?.filter((x) => x.catName === "UG" || x.catName === "PG")
              //         .map((x) => x.catId)}, )}

              //         onChange={(selectedValues) => {
              //           const segmentIds = formValueSetup.stream
              //           ?.filter((x) => x.catName === "UG" || x.catName === "PG")
              //           .map((x) => x.catId);
              //           segmentIds.forEach((id) => {
              //             if (!selectedValues.includes(id)) {
              //               selectedValues.push(id);
              //             }
              //           });
              //           form.setFieldsValue({ Stream_type: selectedValues }); 
              // }}
              >
                {formValueSetup.stream
                  ? formValueSetup.stream.map((x, index) => (
                    <Option key={index} value={x.catId}>
                      {x.catName}
                    </Option>
                  ))
                  : ""}
              </Select>
            </Form.Item>
          </Col>

          <Col style={{ width: "30%", paddingLeft: 10 }}>
            <Form.Item
              label="Country"
              name="Country"
              rules={[{ required: true, message: "Please select a country!" }]}
            >
              <Select placeholder="Select a country"
                defaultValue={form.setFieldsValue({
                  Country: formValueSetup.country
                    ?.filter((x) => x.catName === "Other")
                    .map((x) => x.catId)
                },)}
              >
                {formValueSetup.country
                  ? formValueSetup.country.map((x, index) => (
                    <Option key={index} value={x.catId} disabled={x.catName === "Australia" || x.catName === "Germany" || x.catName === "India" || x.catName === "Ireland" || x.catName === "UK" || x.catName === "USA"}>
                      {x.catName}
                    </Option>
                  ))
                  : ""}
              </Select>
            </Form.Item>
          </Col>



          <Col
            style={{
              width: "30%",
              paddingLeft: 10,
              display: "flex",
              flexBasis: "content",
            }}
          >
            <Form.Item
              label="Pricing Type"
              name="Pricing_type"
              rules={[
                { required: true, message: "Please select a pricing type!" },
              ]}
            >
              <Radio.Group
                block
                options={slabOptions1}
                onChange={handleSlabRadioClicked}
                buttonCheckedBg="#1b8593"
              />
            </Form.Item>
            <div style={{ marginTop: "17%" }}>
              {fixedStaus || dataSource.length > 0 ? (
                <>
                  <Link
                    onClick={handleSlabViewClicked}
                    style={{
                      color: "rgb(27, 133, 147)",
                      fontWeight: "200",
                      fontSize: "0.7rem",
                      padding: "0.3rem",
                      border: "1px solid",
                      borderRadius: "0.3rem",
                    }}
                  >
                    <EyeOutlined />
                    View
                  </Link>
                </>
              ) : (
                ""
              )}
            </div>

            <Modal
              open={drawerOpen}
              closable={false}
              className="modal-container"
              centered
              footer={null}
            >
              {fixedStaus ? (
                <Form.Item
                  label="Fixed Percentage"
                  name="Fixed_percentage"
                  rules={[
                    { required: true, message: "Please add Fixed Percentage" },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Fixed percentage"
                    min={0}
                    max={99.99}
                    step={0.01}
                    value={fixedPercentage === "" ? null : Number(fixedPercentage)}
                    formatter={value => (value !== undefined && value !== null ? `${value}%` : "")}
                    parser={value => {
                      // Remove % and keep only valid number with up to 2 decimals
                      const parsed = value ? value.replace(/[^\d.]/g, "") : "";
                      return parsed === "" ? "" : Math.max(0, Math.min(100, Number(Number(parsed).toFixed(2))));
                    }}
                    onChange={val => setFixedPercentage(val === null ? "" : val)}
                  />
                  {/* <Input
                    placeholder="Fixed percentage"
                    onChange={(e) => setFixedPercentage(e.target.value)}
                  /> */}
                </Form.Item>
              ) : (
                <>
                  <Row>
                    <Col lg={12} xs={12} md={12} sm={12}>
                      <Col
                        md={12}
                        className="headre-login"
                        style={{ maxWidth: "100%" }}
                      >
                        <ModalHeaderText LoginHeading="Add Price Slab" />
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={12}
                      xs={12}
                      md={12}
                      sm={12}
                      style={{
                        maxWidth: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {dataSource.length > 0 && (
                        <>
                          <Form.Item
                            label="Retrospective"
                            name="Retrospective"
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: "Please select Retrospective",
                          //   },
                          // ]}
                          >
                            <Radio.Group
                              block
                              options={RetroOptions}
                              defaultValue="No"
                              onChange={(e) => console.log(e.target.value)}
                              buttonCheckedBg="#1b8593"
                            />
                          </Form.Item>

                          <Table
                            dataSource={dataSource}
                            pagination={{ pageSize: 3 }}
                            columns={[
                              {
                                title: "Minimum slab",
                                dataIndex: "MinimumSlab",
                                key: "MinimumSlab",
                              },
                              {
                                title: "Maximum slab",
                                dataIndex: "MaximumSlab",
                                key: "MaximumSlab",
                              },
                              {
                                title: "Percentage",
                                dataIndex: "Percentage",
                                key: "Percentage",
                              },
                              {
                                title: "Action",
                                dataIndex: "Action",
                                key: "Action",
                              },
                            ]}
                          />
                        </>
                      )}
                      <Space style={{ marginBottom: 16 }}>
                        <Input
                          placeholder="Minimum Slab"
                          type="number"
                          value={minSlab}
                          onChange={(e) => setMinSlab(e.target.value)}
                        />
                        <Input
                          placeholder="Maximum Slab"
                          type="number"
                          value={maxSlab}
                          onChange={(e) => setMaxSlab(e.target.value)}
                        />
                        <InputNumber
                          min={0.01}
                          max={99.99}
                          step={0.01}
                          value={percentage === "" ? null : Number(percentage)}
                          formatter={value => (value !== undefined && value !== null ? `${value}%` : "")}
                          parser={value => {
                            // Remove % and keep only valid number with up to 2 decimals
                            const parsed = value ? value.replace(/[^\d.]/g, "") : "";
                            return parsed === "" ? "" : Math.max(0, Math.min(100, Number(Number(parsed).toFixed(2))));
                          }}
                          onChange={val => setPercentage(val === null ? "" : val)}
                        />
                        {/* <Input
                          placeholder="Percentage"
                          value={percentage}
                          onChange={(e) => setPercentage(e.target.value)}
                        /> */}
                        {pricingEdit ? (
                          <Button
                            type="primary"
                            size={"small"}
                            onClick={handleAddEditedEntry}
                            style={{ background: "#1b8593" }}
                          >
                            Add
                            {/* <PlusCircleOutlined /> */}
                          </Button>
                        ) : (
                          <Button
                            type="primary"
                            size={"small"}
                            onClick={handleAddEntry}
                            style={{ background: "#1b8593" }}
                          >
                            Add
                            {/* <PlusCircleOutlined /> */}
                          </Button>
                        )}
                      </Space>
                    </Col>
                  </Row>
                </>
              )}
              <Row>
                <Col lg={12} xs={12} md={12} sm={12}>
                  {fixedStaus ? (
                    <>
                      <Button
                        className="mr-3"
                        htmlType="button"
                        type="default"
                        onClick={handleCancelFixed}
                        style={{ background: "#1b8593" }}
                      >
                        CANCEL
                      </Button>
                      <Button
                        className="m-3"
                        htmlType="button"
                        onClick={handleConfirmFixed}
                        type="primary"
                        style={{ background: "#1b8593" }}
                      >
                        CONFIRM
                      </Button>
                    </>
                  ) : (
                    <>
                      <Button
                        className="mr-3"
                        htmlType="button"
                        type="default"
                        onClick={handleCancel}
                        style={{ background: "#1b8593" }}
                      >
                        CANCEL
                      </Button>
                      <Button
                        className="m-3"
                        htmlType="button"
                        onClick={handleConfirm}
                        type="primary"
                        style={{ background: "#1b8593" }}
                      >
                        CONFIRM
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            </Modal>
          </Col>

          <Col
            style={{ width: "90%", justifyItems: "end", alignContent: "end" }}
          >
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: 8, background: "#1b8593" }}
              >
                Add
              </Button>

              <Button
                htmlType="button"
                onClick={onReset}
                style={{ background: "#1b8593" }}
              >
                Reset
              </Button>
            </Form.Item>
          </Col>
        </Form>
      </Card>
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    categorySetup: (data) => dispatch(getCategoryList(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    formSetup: state.pricingFormSetup.formSetupCtegory,
    existingPricingDetail: state.AddPricingDetail.getPricingPartnerDetail,
    loading: state.pricingFormSetup.loading,
    error: state.pricingFormSetup.error,
    accessToken: state && state.auth && state.auth.idToken,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFormQuery);
